import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import ProcessoService from '@services/ProcessoService';

const useTratamentoDataNascimentoTiposPendencia = () => {
    const fetch = useCallback(() => ProcessoService.listarTiposPendenciasTratamentoDataNascimento(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useTratamentoDataNascimentoTiposPendencia;